import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconEmailSvg } from "./IconEmailSvg.mjs";
const IconEmail = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconEmailSvg, ...iconProps });
};
export {
  IconEmail
};
